// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__8O79H","disabled":"button_disabled__1KDkh button_button__8O79H"};